import React from "react";
import { LeftMenu } from "./menu/LeftMenu";
import { useCommonWidths } from "../../../hooks";
import { Drawer } from "@material-ui/core";
import { FAQ } from "./menu/FAQ";
import { MyProfile } from "./menu/MyProfile";

export enum Menu {
	None,
	LeftMenu,
	FAQ,
	MyProfile,
}
interface SideMenuProps {
	toggleMenu: (item: Menu) => void;
	open: Menu;
}
export const SideMenus = (props: SideMenuProps) => {
	const isMobile = useCommonWidths().isSmDown;
	const { open, toggleMenu } = props;

	return (
		<>
			<Drawer
				anchor="left"
				open={!isMobile || open === Menu.LeftMenu}
				variant={isMobile ? "temporary" : "persistent"}
				onClose={() => {
					toggleMenu(Menu.LeftMenu);
				}}
			>
				<LeftMenu toggleMenuOpen={() => toggleMenu(Menu.LeftMenu)} />
			</Drawer>
			<FAQ open={open === Menu.FAQ} toggleMenu={() => toggleMenu(Menu.FAQ)} />
			<MyProfile
				open={open === Menu.MyProfile}
				toggleMenu={() => toggleMenu(Menu.MyProfile)}
			/>
		</>
	);
};
